// extracted by mini-css-extract-plugin
export default {"name":"FeedbackGreeting_name__0DMUk","description":"FeedbackGreeting_description__HMXTh","spin":"FeedbackGreeting_spin__E2Ul-"};